type Timer = ReturnType<typeof setTimeout>;
type SomeFunction = (...args: any[]) => void;

export type DebouncedFunction<Func extends SomeFunction> = Func & {
  cancel: () => void;
};

/**
 *
 * @param func The original, non debounced function (You can pass any number of args to it)
 * @param delay The delay (in ms) for the function to return
 * @returns The debounced function, which will run only if the debounced function has not been called in the last (delay) ms
 */
function debounce<Func extends SomeFunction>(func: Func, delay = 1000): DebouncedFunction<Func> {
  let timer: Timer | null = null;

  const debouncedFunction = ((...args) => {
    if (timer !== null) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      timer = null;
      func(...args);
    }, delay);
  }) as DebouncedFunction<Func>;

  debouncedFunction.cancel = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return debouncedFunction;
}

export default debounce;
